import {H1, TextRegular} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {KilnValidationErrorAlert} from './KilnValidationErrorAlert'
import {KilnValidationErrorImage} from './KilnValidationErrorImage'

interface KilnValidationErrorProps {
  isKilngConfigValid: boolean
  areHeatZonesValid: boolean
  areDrillingSettingsValid: boolean
}

// HCP-98946: update with a generic version of error from fundamental library
export const KilnValidationError: React.FC<KilnValidationErrorProps> = ({
  isKilngConfigValid,
  areHeatZonesValid,
  areDrillingSettingsValid
}) => {
  const {t} = useTranslation()

  return (
    <div
      className="mx-auto flex max-w-[500px] flex-col items-center justify-center h-screen gap-6 py-12 px-6 text-center"
      data-cy="incomplete_setup_page"
    >
      <KilnValidationErrorImage />
      <H1>{t('error.kilnValidationTitle')}</H1>
      <TextRegular>{t('error.kilnValidationDescription')}</TextRegular>
      <div className="flex flex-col gap-3 w-full">
        {!isKilngConfigValid && (
          <KilnValidationErrorAlert
            description={t('warning.kilnLayoutSetupAlert')}
            buttonText={t('warning.kilnLayoutSetupButton')}
            settingsTab="layout"
          />
        )}
        {!areHeatZonesValid && (
          <KilnValidationErrorAlert
            description={t('warning.kilnHeatZonesAlert')}
            buttonText={t('warning.kilnHeatZonesButton')}
            settingsTab="heatZones"
          />
        )}
        {!areDrillingSettingsValid && (
          <KilnValidationErrorAlert
            description={t('warning.kilnDrillingsAlert')}
            buttonText={t('warning.kilnDrillingsButton')}
            settingsTab="drillingZones"
          />
        )}
      </div>
    </div>
  )
}
